let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dQsRO")).then(() => parcelRequire('gwOgn'));